<div class="form-field">
  <span class="form-field-label">画像</span>
  <div *ngIf="!image" class="image-add">画像を追加する</div>
  <div class="image-wrap"><img *ngIf="image" [src]="image" alt="" /></div>
  <input
    type="file"
    accept="image/*"
    (change)="onChange($any($event.target).files)"
    #camera
  />
  <button
    type="button"
    mat-stroked-button
    class="camera-button"
    (click)="camera.click()"
  >
    写真
  </button>
</div>
